<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      兴围站<br>
站点介绍<br>
兴围站位于兴华路与广深公路交叉路口的北侧处，周边分布了天虹超市、星航中心、科技大厦、星航华府等多个项目,车站周边现状以住宅和商业为主，车站为地下站，地下一层为站厅层，地下二层为站台层，车站设有自动扶梯、垂梯、公共洗手间等便民设施。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:07	23:47	12号线	4分钟	8分钟<br>
海上田园东	06:45	23:25	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:08	23:47	12号线	8分钟	8分钟<br>
海上田园东	06:45	23:25	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
C 出入口:<br>
广深公路南侧、星航华府、天虹商场<br><br>
D 出入口:<br>
广深公路南侧、深圳市星航中心、兴围怡丰酒店、天虹商场<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 星航华府微巴场站<br>
B929<br><br>
D出入口:<br>
公交站名： 宝安交警大队1<br>

  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>